export default __webpack_public_path__ + "static/media/shares.e6522d88.png";